<template>
  <section
    v-if="reviews"
    class="my-100"
  >
    <div class="container">
      <div class="pr-60">
        <h2 class="wysiwyg-title text-3xl md:text-4xl text-secondary">
          {{ reviews.noReviews }} {{ $t('inspiration.scores') }}
          <strong>{{ (reviews.score * 2) }} / {{ (reviews.scoremax * 2) }}</strong>
        </h2>
      </div>

      <Swiper
        v-if="reviews.reviewDetails.reviewDetail.length"
        slides-per-view="auto"
        navigation
        :modules="[SwiperNavigation]"
        class="mt-25 [&.swiper]:overflow-visible"
        grab-cursor
      >
        <SwiperSlide
          v-for="(review, index) in reviews.reviewDetails.reviewDetail"
          :key="`review-${index}`"
          class="mr-30 last:mr-0"
        >
          <div class="p-40 w-full bg-primary-100 text-primary-700 h-full pointer-events-none">
            <span
              class="flex items-center space-x-2 text-primary-500"
            >
              <template v-for="i in 5">
                <starFilledIcon
                  v-if="i <= review.score"
                  :key="`star-filled-${i}`"
                />
                <starHalfIcon
                  v-else-if="(i - 0.5) <= review.score"
                  :key="`star-half-${i}`"
                />
                <starIcon
                  v-else
                  :key="`star-${i}`"
                />
              </template>
              <span class="translate-y-1 pl-5">{{ (review.score * 2) }}/{{ (review.scoremax * 2) }}</span>
            </span>
            <p class="text-lg mt-20">
              <b>{{ review.text }}</b>
            </p>
            <p class="font-serif font-bold text-lg text-primary-500 mt-20">
              {{ review.user }}
            </p>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  </section>
</template>

<script setup>
import { useState, SwiperNavigation } from '#imports';

// General icons
import starIcon from '@/assets/img/icon-star.svg';
import starHalfIcon from '@/assets/img/icon-star-half.svg';
import starFilledIcon from '@/assets/img/icon-star-filled.svg';

// States
const reviews = useState('reviews');
</script>
